/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateInvestigationLockRequest
 */
export interface CreateInvestigationLockRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInvestigationLockRequest
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvestigationLockRequest
     */
    personGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvestigationLockRequest
     */
    accountGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateInvestigationLockRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the CreateInvestigationLockRequest interface.
 */
export function instanceOfCreateInvestigationLockRequest(value: object): value is CreateInvestigationLockRequest {
    return true;
}

export function CreateInvestigationLockRequestFromJSON(json: any): CreateInvestigationLockRequest {
    return CreateInvestigationLockRequestFromJSONTyped(json, false);
}

export function CreateInvestigationLockRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateInvestigationLockRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'personGoldenId': json['personGoldenId'] == null ? undefined : json['personGoldenId'],
        'accountGoldenId': json['accountGoldenId'] == null ? undefined : json['accountGoldenId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function CreateInvestigationLockRequestToJSON(json: any): CreateInvestigationLockRequest {
    return CreateInvestigationLockRequestToJSONTyped(json, false);
}

export function CreateInvestigationLockRequestToJSONTyped(value?: CreateInvestigationLockRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'personGoldenId': value['personGoldenId'],
        'accountGoldenId': value['accountGoldenId'],
        'reason': value['reason'],
    };
}

